import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFullscreen1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFullscreen1"><Path d="M3.5 14V18.5H8V20H2V14H3.5ZM22 14V20H16V18.5H20.5V14H22ZM8 4V5.5H3.5V9.75H2V4H8ZM22 4V9.75H20.5V5.5H16V4H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFullscreen1;
